import { render, staticRenderFns } from "./culture-chunk.vue?vue&type=template&id=c50f396c&scoped=true"
import script from "./culture-chunk.vue?vue&type=script&lang=js"
export * from "./culture-chunk.vue?vue&type=script&lang=js"
import style0 from "./culture-chunk.vue?vue&type=style&index=0&id=c50f396c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50f396c",
  null
  
)

export default component.exports